import React, { FC } from 'react';
import styled from 'styled-components';
import {
  BROWSER_BREAKPOINTS,
  CompanyAddress,
  CompanyEmail,
  CompanyLicense,
  CompanyPhone,
  CompanyTitle,
  CompanyWebsiteUrl,
  CustomerAddress,
  CustomerEmail,
  CustomerLeadSourceName,
  CustomerName,
  CustomerPhone,
  Job,
  MainLayoutHeader,
  MainLayoutHeaderColumn,
  SignatureRequestSection,
} from '@flicent/fieldpulse-react-component-library-frontend';

import { JobDetailedRecord, JobSummaryTable } from '@/components';
import { JobReportProps } from './JobReport.props';


const StyledRoot = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 50px;

  @media screen and ${ BROWSER_BREAKPOINTS.MOBILE } {
    grid-row-gap: 25px;
  }
`;

const JobReport: FC<JobReportProps> = ({
                                         company,
                                         customer,
                                         jobs,

                                         isShowSignatureRequest,
                                         isSignaturesAccepted,
                                         acceptedSignaturesPdfUrl,
                                         onSignaturesAccept,
                                       }) => {
  let contentComponent;

  if (company && customer && jobs) {
    const signatureRequestSectionComponent = isShowSignatureRequest && <SignatureRequestSection
      isAccepted={ isSignaturesAccepted }
      reportTitle="The Jobs Report"
      pdfUrl={ acceptedSignaturesPdfUrl }
      onAccept={ (signerName, signatures) => onSignaturesAccept(signatures) }
    />;

    contentComponent = (
      <>
        <MainLayoutHeader
          isLogoVisible={ company.is_logo_visible }
          logoSrc={ company.logo_src }
          companyTitleForLogoAlt={ company.company_title }

          slotTopColumn1={ customer.is_job_company_header_visible ? <MainLayoutHeaderColumn>
            <CompanyTitle isCompanyTitleVisible={ company.is_company_title_visible }
                          companyTitle={ company.company_title }/>
            <CompanyLicense licenseNumber={ company.license_number }/>
            <CompanyAddress address={ company.address }/>
            <CompanyPhone phone={ company.phone }/>
            <CompanyEmail email={ company.email }/>
            <CompanyWebsiteUrl websiteUrl={ company.website_url }/>
          </MainLayoutHeaderColumn> : null }

          slotTopColumn2={ customer.is_job_customer_header_visible ? <MainLayoutHeaderColumn>
            <CustomerName displayName={ customer.display_name }/>
            <CustomerPhone phone={ customer.phone }/>
            { customer.is_email_visible && <CustomerEmail email={ customer.email }/> }
            <CustomerAddress isAddressVisible={ customer.is_address_visible }
                             isBillingAddressVisible={ customer.is_billing_address_visible }
                             isBillingNameVisible={ customer.is_billing_name_visible }
                             nameWithoutParent={ customer.name_without_parent }
                             address={ customer.address }/>
            { customer.is_lead_source_name_visible &&
              <CustomerLeadSourceName leadSourceName={ customer.lead_source_name }/> }
          </MainLayoutHeaderColumn> : null }
        />

        <JobSummaryTable company={ company } jobs={ jobs }/>

        { signatureRequestSectionComponent }

        { jobs.map((job: Job) => <JobDetailedRecord key={ job.cuid } job={ job }/>) }

        { signatureRequestSectionComponent }
      </>
    );
  }


  return (
    <StyledRoot>
      { contentComponent }
    </StyledRoot>
  );
};


export default JobReport;
